import { browserCheck } from '@ta-interaktiv/browsercheck'

export const config: {
  isMobile: boolean
  cantonnames: {
    [key: string]: string
  }
  ageclasses: {
    [key: string]: string
  }
  ages: string[]
  colorrange: string[]
  colorrange_reversed: string[]
} = {
  isMobile: browserCheck.isMobile,
  cantonnames: {
    ZH: 'Kanton Zürich',
    SG: 'Kanton St. Gallen',
    VD: 'Kanton Waadt',
    VS: 'Kanton Wallis',
    AR: 'Kanton Appenzell Ausserrhoden',
    ZG: 'Kanton Zug',
    TI: 'Kanton Tessin',
    BE: 'Kanton Bern',
    BL: 'Kanton Basel-Landschaft',
    BS: 'Kanton Basel-Stadt',
    AG: 'Kanton Aargau',
    AI: 'Kanton Appenzell Innerrhoden',
    FR: 'Kanton Freiburg',
    GE: 'Kanton Genf',
    GR: 'Kanton Graubünden',
    JU: 'Kanton Jura',
    LU: 'Kanton Luzern',
    NE: 'Kanton Neuenburg',
    OW: 'Kanton Obwalden',
    SH: 'Kanton Schaffhausen',
    SO: 'Kanton Solothurn',
    SZ: 'Kanton Schwyz',
    TG: 'Kanton Thurgau',
    UR: 'Kanton Uri',
    GL: 'Kanton ',
    NW: 'Kanton Nidwalden',
    CH: 'Schweiz'
  },
  ageclasses: {
    '0+': '0 - 9',
    '10+': '10 - 19',
    '20+': '20 - 29',
    '30+': '30 - 39',
    '40+': '40 - 49',
    '50+': '50 - 59',
    '60+': '60 - 69',
    '70+': '70 - 79',
    '80+': '80+'
  },
  ages: ['80+', '70+', '60+', '50+', '40+', '30+', '20+', '10+', '0+'],
  colorrange: ['#202346', '#d3343f', '#FFE462'],
  colorrange_reversed: ['#FFE462', '#d3343f', '#202346']
}

const getLuminanace = (values: number[]) => {
  const rgb = values.map(v => {
    const val = v / 255
    return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4
  })
  return Number(
    (0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3)
  )
}
export const getContrastRatio = (colorA: number[], colorB: number[]) => {
  const lumA = getLuminanace(colorA)
  const lumB = getLuminanace(colorB)
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05)
}
export const formattedDate = (d = new Date()) => {
  let month = String(d.getMonth() + 1)
  let day = String(d.getDate())
  const year = String(d.getFullYear())

  if (month.length < 2) month = '0' + month
  if (day.length < 2) day = '0' + day

  return `${+day}.${+month}`
}

export const getDateOfISOWeek = (w: number, y: number) => {
  var simple = new Date(y, 0, 1 + (w - 1) * 7)
  var dow = simple.getDay()
  var ISOweekStart = simple
  if (dow <= 4) ISOweekStart.setDate(simple.getDate() - simple.getDay() + 1)
  else ISOweekStart.setDate(simple.getDate() + 8 - simple.getDay())
  return ISOweekStart
}
